import { Link } from 'react-router-dom';

export default function RecentBlogs() {
  const blogs = [
    {
      id: 1,
      title: '何时选用 Adobe PDF Converter SDK',
      excerpt: '对于有高吞吐量、高精度 PDF 生成需求的企业组织而言，Adobe PDF Converter SDK 提供了一款专为 OEM 工作流打造的高性能、可定制化引擎。了解如何通过该工具包实现自动化、集成化与精细化管控。',
      date: '2026年2月5日',
      category: '产品指南',
      readTime: '12分钟',
      link: '/blog-pdf-converter-sdk',
      image: 'https://static.readdy.ai/image/8dfcde88d6d872f7d495e2c3222a324c/fc0dc12eff12521a89283b60ef11764d.jpeg'
    },
    {
      id: 2,
      title: '保护您的PDF：阻止AI模型抓取您的数据',
      excerpt: '随着AI技术的快速发展，PDF文档中的数据正面临前所未有的抓取风险。本文深入探讨如何通过技术手段和策略保护您的PDF数据，防止被AI模型未经授权地抓取和使用。',
      date: '2026年1月14日',
      category: '数据安全',
      readTime: '16分钟',
      link: '/blog-ai-scraping-pdfs',
      image: 'https://public.readdy.ai/ai/img_res/c8e20da778969f63ff955b619d144f11.jpg'
    },
    {
      id: 3,
      title: '2025年PDF技术趋势：AI视角下的行业洞察',
      excerpt: '通过向ChatGPT、Gemini、Claude和Copilot四大AI模型提问，我们深入分析了2025年PDF技术的发展趋势，包括平台级集成、AI自动化、云端移动化以及安全合规等关键领域。',
      date: '2026年2月1日',
      category: '行业趋势',
      readTime: '12分钟',
      link: '/blog-pdf-trends-2025',
      image: 'https://readdy.ai/api/search-image?query=Futuristic%20technology%20trends%20visualization%20showing%20PDF%20document%20evolution%20with%20AI%20integration%2C%20modern%20digital%20transformation%20concept%20with%20data%20analytics%20charts%20and%20cloud%20computing%20elements%2C%20teal%20and%20cyan%20gradient%20background%20with%20abstract%20tech%20patterns%2C%20professional%20business%20illustration%20representing%202025%20technology%20forecast%20and%20innovation&width=800&height=500&seq=blog-pdf-trends-future&orientation=landscape'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-white to-gray-50" aria-labelledby="recent-blogs-heading">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <header className="text-center mb-16">
          <h2 id="recent-blogs-heading" className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            <strong>最新博客文章</strong>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            探索PDF技术的最新趋势、安全策略和企业级解决方案
          </p>
        </header>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {blogs.map((blog) => (
            <article 
              key={blog.id}
              className="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 flex flex-col cursor-pointer group"
            >
              <Link to={blog.link} className="block">
                <div className="relative h-48 w-full overflow-hidden">
                  <img 
                    src={blog.image}
                    alt={blog.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                  />
                  <div className="absolute top-4 left-4">
                    <span className="bg-teal-600 text-white px-3 py-1 rounded-full text-sm font-semibold">
                      {blog.category}
                    </span>
                  </div>
                </div>
                
                <div className="p-6 flex flex-col flex-grow">
                  <div className="flex items-center gap-4 text-sm text-gray-500 mb-3">
                    <time dateTime={blog.date} className="flex items-center gap-1">
                      <i className="ri-calendar-line w-4 h-4 flex items-center justify-center"></i>
                      {blog.date}
                    </time>
                    <span className="flex items-center gap-1">
                      <i className="ri-time-line w-4 h-4 flex items-center justify-center"></i>
                      {blog.readTime}
                    </span>
                  </div>
                  
                  <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-teal-600 transition-colors line-clamp-2">
                    {blog.title}
                  </h3>
                  
                  <p className="text-gray-600 mb-4 flex-grow line-clamp-3">
                    {blog.excerpt}
                  </p>
                  
                  <div className="flex items-center text-teal-600 font-semibold group-hover:gap-2 transition-all">
                    阅读更多
                    <i className="ri-arrow-right-line ml-2 w-5 h-5 flex items-center justify-center group-hover:translate-x-1 transition-transform"></i>
                  </div>
                </div>
              </Link>
            </article>
          ))}
        </div>

        <div className="text-center">
          <Link 
            to="/resources"
            className="inline-flex items-center gap-2 bg-teal-600 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-teal-700 transition-colors shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            查看所有博客文章
            <i className="ri-arrow-right-line w-5 h-5 flex items-center justify-center"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}